import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { VideoProgress } from '@core/models/video-progress';
import { Video } from '@core/models/video';
import { ConfigService } from './config.service';

@Injectable({
	providedIn: 'root'
})
export class VideoHttpService {

	private http = inject(HttpClient);
	private configService = inject(ConfigService);

	public getVideoContent(slug: string): Observable<any> {

		return this.http.get<any>(`${this.configService.contentEndpoint}/video/${slug}`);
	}

	public getPlaylist(uuid: string): Observable<any> {

		return this.http.get<any>(`${this.configService.playlistEndpoint}/playlist/${uuid}?platform=website`);
	}

	public getProgress(uuid: string): Observable<VideoProgress> {

		return this.http.get<VideoProgress>(`${this.configService.myndbandaEndpoint}/progress/${uuid}`);
	}

	public getProgressList(): Observable<VideoProgress[]> {

		return this.http.get<VideoProgress[]>(`${this.configService.myndbandaEndpoint}/progress`).pipe(
			map((res: any) => {

				return res.progress;
			}));
	}

	public storeProgress(uuid: string, progress: number): Observable<any> {

		return this.http.post<any>(`${this.configService.myndbandaEndpoint}/measure`, { uuid: uuid, progress: progress, platform_name: 'Website' });
	}

	// todo move to account service
	public getKeepWatching(): Observable<any> {

		return this.http.get<any>(`${this.configService.accountEndpoint}/user/keep-watching`).pipe(
			map((res: any) => {

				return res.watch_further;
			}));
	}

	public getRecommendations(): Observable<Video[]> {

		return this.http.get<Video[]>(`${this.configService.accountEndpoint}/user/recommendations?max=24&start=2024-01-01`).pipe(
			map((res: any) => {

				return res.recommendations;
			}));
	}
}